const MoinAhmedMalik = () => {
  return (
    <div>
      <div className="bg-[#fcfcfc] pt-[2rem]">
        <div className="max-w-[70rem] mx-auto sm:px-[10rem] lg:flex md:grid md:justify-center lg:justify-between items-end">
          <div className="mb-[2.5rem] lg:grid hidden">
            <h1 className="lg:text-[30px] md:text-[30px] sm:text-[30px] font-bold">
              Hamid Farooq
            </h1>
            <p>CEO TCS Private Limited</p>
          </div>
          <div className="flex justify-end mx-[2rem]">
            <img
              src="/leadershipnew/hamid-farooq.jpg"
              alt=""
              className="xl:h-[26rem] lg:h-[26rem] md:h-[20rem] sm:h-[20rem] h-[17rem] leadership-images"
            />
          </div>
          <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]">
            <h1 className="sm:text-[30px] text-[26px] font-bold">
              Hamid Farooq
            </h1>
            <p>CEO TCS Private Limited</p>
          </div>
        </div>
      </div>
      <div className="sm:max-w-[50rem] lg:mx-auto md:mx-[5rem] mx-[2rem] my-[4rem] flex flex-col justify-center items-center text-justify gap-4">
        <p>
          With over three decades within the telecom, consulting, oil & gas,
          banking, finance, services, and logistics sectors, Mr. Farooq brings
          rich experience at the C-level, leading complex commercial operations,
          turning around struggling companies, and driving growth. His expertise
          spans multiple functions, including finance, HR, sales, marketing,
          business development, and commercial operations, where he has
          successfully enhanced profitability and shareholder value.
        </p>
        <p>
          Since 1993, Mr. Farooq has been a core founding member of several
          companies, playing a pivotal role in setting up new ventures and
          achieving significant success. With over 19 years in the telecom
          industry, he has achieved remarkable milestones, such as creating a
          US$ 2.9B enterprise value and reaching positive EBITDA within 17
          months of launching a telecom project. He has also developed strong
          relationships with key stakeholders, including government officials
          and industry regulators, to shape the telecom landscape in Pakistan.
        </p>
        <p>
          His career highlights include leading U Bank (Microfinance Bank),
          Pakistan Telecommunication Company, Warid Telecom, and Jazz (formerly
          Mobilink). Most recently, he managed a US$725M pension fund for
          Pakistan Telecommunications Employees Trust, transforming it into a
          fund-surplus entity. Mr. Farooq has demonstrated his entrepreneurial
          spirit by establishing mobile money and micro-financing entities,
          earning multiple industry awards.
        </p>
        <p>
          Outside of his professional life, Mr. Farooq values work-life balance,
          engaging in travel, fitness, and golf. He is admired for his
          mentorship and leadership, making him a role model for new employees
          seeking guidance.
        </p>
      </div>
    </div>
  );
};

export default MoinAhmedMalik;
